import React from 'react';
import { Link } from 'react-router-dom';
import { slugify } from '../../../utils';

const DataSet = ( { data, classes, bgWhite } ) => {
 // console.log(data);
    return (
        <div className={`edu-blog blog-type-2 radius-small ${classes ? classes : '' } ${bgWhite === 'enable' ? 'bg-color-white' : '' }`}>
            <div className="inner">
                <div className="thumbnail">
                    <Link to={{ pathname: `/blog-details/${data.id}`}} state={{data:data}}>
                        <img src={`${process.env.PUBLIC_URL}${data.image}`} alt="Blog Thumb" />
                    </Link>
                    {/* <Link to={{ pathname: `/blog-details/${data.id}`}} state={{data:data}}> Click </Link> */}
                </div>
                <div className="content">
                    <div className="status-group">
                        {/* <Link className="eduvibe-status status-05" to={process.env.PUBLIC_URL + `/category/${ slugify( data.categories.slice( 0, 1 ) ) }`}>
                            <i className="icon-price-tag-3-line"></i> {data.categories.slice(0, 1)}
                        </Link> */}
                    </div>
                    <h6 className="title" style={{fontSize:"16px"}}>
                        <Link to={{ pathname: `/blog-details/${data.id}`}} state={{data:data}}>{data.title}</Link>
                        <p style={{fontSize:"12px",color:"#a3a3a3"}}> </p>
                        <p style={{fontSize:"12px",color:"#a3a3a3"}}>
                        <Link  to={{ pathname: `/blog-details/${data.id}`}} state={{data:data}}>{data.readingTime}</Link> <br></br>
                        <Link  to={{ pathname: `/blog-details/${data.id}`}} state={{data:data}}>{data.details}</Link>
                        </p>
                    </h6>
                    <div className="blog-card-bottom">
                        {/* <ul className="blog-meta">
                            <li><i className="icon-calendar-2-line"></i>{ data.date }</li>
                        </ul> */}
                        <div className="read-more-btn">
                            <Link className="btn-transparent" to={{ pathname: `/blog-details/${data.id}`}} state={{data:data}}>
                                Read More<i className="icon-arrow-right-line-right"></i></Link>
                                {console.log(data)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DataSet;